export const skills = {
  Languages: ["JavaScript", "TypeScript", "Java", "Python", "SQL"],
  Frameworks: ["React", "Django", "Node.js", "Spring Boot", "Next.js", "Expo", "Express"],
  Tools: ["Docker", "Kubernetes", "Jenkins", "RabbitMQ", "n8n", "Git", "Postman", "Coolify"],
  Database: ["PostgreSQL", "MySQL", "MongoDB", "Redis", "Supabase"],
  ITS_Systems: ["Microsoft 365", "Teams", "OneDrive", "IAM", "Networking", "Reporting & Dashboards"]
};